document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('deal-swiper')) {
        customElements.define(
            'deal-swiper',
            class dealSwiper extends HTMLElement {
                // 监听的属性
                constructor() {
                    super();
                    this._swiper = null;
                    this._initialized = false;
                }

                connectedCallback() {
                    requestAnimationFrame(() => {
                        this._initSwiper();
                    });
                }

                _initSwiper() {
                    if (this._initialized) return;
                    const container = this.querySelector('.swiper');
                    const config = {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        breakpoints: {
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 20,

                            }
                        },
                        navigation: {
                            nextEl: this.querySelector('.swiper-button-next'),
                            prevEl: this.querySelector('.swiper-button-prev'),
                        },
                        pagination: {
                            el: this.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                        observeSlideChildren: true,
                    };

                    this._swiper = new Swiper(container, config);
                    this._initialized = true;
                }
                updateSwiper() {
                    if (!this._swiper) return;
                    this._swiper.update();
                }

                disconnectedCallback() {
                    if (this._swiper) {
                        this._swiper.destroy(true, true);
                        this._swiper = null;
                        this._initialized = false;
                    }
                }
            }
        );
    }

    const codeDetail = JSON.parse(
        document.getElementById("deals-code-detail").textContent
    );

    let discountRate
    const currentHandle = document.getElementById("deals-code-detail").dataset.handle
    // 产品容器
    const hotProductSwiper = document.querySelector('deal-swiper')
    const defaultHotProduct = document.querySelectorAll('deal-swiper .swiper-slide.deal-hot-regular-product')
    const discountHotProduct = document.querySelectorAll('deal-swiper .swiper-slide.deal-hot-discount-product')

    // 常规的banner图片/文案
    const banner_pc = $('.deals_banner_image_pc')
    const banner_mb = $('.deals_banner_image_mb')

    const video_banner_mb = $('.deals_banner_video_mb')

    const reguler_banner_pc = $('.deals_banner_image_pc').attr('src')
    const regular_banner_mb = $('.deals_banner_image_mb').attr('src')

    const banner_title = $('.deals_sign_text .pc-title .heading')
    const banner_subtitle = $('.deals_sign_text .pc-title .subheading')
    const regular_title = $('.deals_sign_text .pc-title .heading').text()
    const regular_subtitle = $('.deals_sign_text .pc-title .subheading').text()


    // review模块
    const dealsReviewsContainer = document.querySelector('.deals_real_reviews .deals-review-product')
    const regularReveiwsProduct = dealsReviewsContainer.querySelectorAll('.regular-slide')
    const discountReveiwsProduct = dealsReviewsContainer.querySelectorAll('.discount-slide')

    function setCookie(name, value) {
        const d = new Date();
        d.setTime(d.getTime() + (14 * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/";
    }

    function getCookie(name) {
        const cname = name + "=";
        const arr = document.cookie.split(';');
        for (let i = 0; i < arr.length; i++) {
            let c = arr[i].trim();
            if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
        }
        return null;
    }



    // 点击折扣码有效期结束事件
    function timeOutEvent() {


        banner_pc.attr('src', reguler_banner_pc)
        banner_pc.attr('srcset', reguler_banner_pc)


        banner_mb.attr('src', regular_banner_mb)
        banner_mb.attr('srcset', regular_banner_mb)


        banner_title.text(regular_title)
        banner_subtitle.text(regular_subtitle)

        banner_mb.removeClass('hide')
        video_banner_mb.addClass('hide')

        defaultHotProduct.forEach(item => {
            item.classList.remove('hide')
        })
        discountHotProduct.forEach(item => {
            item.remove()
        })
        hotProductSwiper.updateSwiper()

        // reviews: 显示常规产品
        regularReveiwsProduct.forEach(item => {
            item.classList.remove('hide')
        })
        discountReveiwsProduct.forEach(item => {
            item.remove()
        })
        dealsReviewsContainer.updateSwiper()
        // 关闭弹窗
        document.querySelector('.product_detail_dialog .product_detail_inner').classList.add('hide')
    }


    // 折扣码有效期的倒计时
    function startCountdown(code) {
        const code_detail = codeDetail.find(
            item => item.code === code
        );
        let end = new Date(code_detail.expiry_time).getTime()
        if (!end) {
            //  如果是分类页且后台没有设置倒计时，跟sale一样按默认循环
            $('.deal-hot-discount-product .new-pro-residueDays-cycle').hide()
            const currentDate = new Date();
            const currentHour = currentDate.getHours();
            // 设置目标时间
            const targetDate = new Date(currentDate);
            // 如果当前时间在15点之前，设置为明天的15点；否则，设置为后天的15点
            if (currentHour < 16) {
                targetDate.setDate(currentDate.getDate() + 1); // 明天
            } else {
                targetDate.setDate(currentDate.getDate() + 2); // 后天
            }
            targetDate.setHours(15, 0, 0, 0); // 设置为15:00
            const newlastdayHTML = targetDate.toISOString(); // ISO格式字符串
            end = new Date(newlastdayHTML);
        }
        const timer = setInterval(() => {
            const now = Date.now();
            const distance = end - now;
            if (distance <= 0) {
                clearInterval(timer);
                // timeOutEvent()
                const cleanUrl = window.location.origin + window.location.pathname
                window.location.href = cleanUrl

                return;
            }
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24))
                / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
                (distance % (1000 * 60 * 60))
                / (1000 * 60)
            );
            const seconds = Math.floor(
                (distance % (1000 * 60))
                / 1000
            );
            $('.deal-hot-discount-product .new-pro-residueDays-cycle').text(String(days).padStart(2, '0') + ":");
            $('.deal-hot-discount-product .new-pro-residueHours-cycle').text(String(hours).padStart(2, '0') + ":");
            $('.deal-hot-discount-product .new-pro-residueMinutes-cycle').text(String(minutes).padStart(2, '0') + ":");
            $('.deal-hot-discount-product .new-pro-residueSeconds-cycle').text(String(seconds).padStart(2, '0'));

        }, 1000);
    }



    // 更新购物车
    function updateCart() {
        const currentPageUrl = window.location.href;
        // 使用当前页面的 URL 发起请求
        $.get(currentPageUrl, function (data) {
            const $tempElement = $('<div>').html(data);
            $('.cartpage-content').html($tempElement.find('.cartpage-content').html());
            $('cart-drawer').html($tempElement.find('cart-drawer').html());
            $('.cart-icon-text').html($tempElement.find('.cart-icon-text').html());
            $('.gift-threshold-banner').html($tempElement.find('.gift-threshold-banner').html());
        }).fail(function (error) {
            console.error('Error updating cart:', error);
        });

    }

    // 更新折扣码
    function updataDiscountCode(code) {
        let formData = new FormData();
        formData.append("discount", code);
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                updateCart()
            });
    }

    // 货币符号
    function parseCurrency(price) {
        // 前置货币符号
        const prefix = price.match(/^[^0-9]+(?=\s*[0-9])/);

        if (prefix) {
            return {
                symbol: prefix[0],
                position: "prefix"
            };
        }

        // 后置货币符号
        const suffix = price.match(/(?<=[0-9])\s*[^0-9.,]+$/);

        if (suffix) {
            return {
                symbol: suffix[0],
                position: "suffix"
            };
        }

        return {
            symbol: "",
            position: null
        };
    }

    // 更新折扣信息
    function updateProductMessage(code) {
        startCountdown(code);
        // 更新图片/文案

        const iso_code = document.querySelector('.deals-hot-product-list').dataset.iso
        const code_detail = codeDetail.find(
            item => item.code === code
        );


        let file_name_pc = code_detail.banner_pc
        let file_name_mb = code_detail.banner_mb

        let code_title = code_detail.title
        let code_subtitle = code_detail.subtitle
         let text_color = code_detail.text_color
        for (let i = 1; i <= 3; i++) {
            const market = code_detail[`market_${i}`];

            if (market?.includes(iso_code)) {
                const title = code_detail[`market_${i}_title`];
                const subtitle = code_detail[`market_${i}_subtitle`];
                const bannerPc = code_detail[`market_${i}_banner_pc`];
                const bannerMb = code_detail[`market_${i}_banner_mb`];
                const textColor = code_detail[`market_${i}_text_color`];

                if (title) code_title = title;
                if (subtitle) code_subtitle = subtitle;
                if (bannerPc) file_name_pc = bannerPc;
                if (bannerMb) file_name_mb = bannerMb;
                if (textColor) text_color = textColor;

                break;
            }
        }
        if (file_name_pc) {
            banner_pc.attr('src', file_name_pc)
            banner_pc.attr('srcset', file_name_pc)
        }
        if (file_name_mb) {
            if (file_name_mb.includes('video')) {
                video_banner_mb.find('video').attr('data-src', file_name_mb)
                video_banner_mb.removeClass('hide')
                banner_mb.addClass('hide')
            } else {
                banner_mb.attr('src', file_name_mb)
                banner_mb.attr('srcset', file_name_mb)
            }
        }

        banner_title.html(code_title)
        banner_subtitle.html(code_subtitle)
       
        if (text_color) {
            banner_title.css('color', text_color)
            banner_subtitle.css('color', text_color)
        }


        let rate = discountRate
        let upTotype = false
        if (rate.includes('up-to')) {
            upTotype = true
            rate = parseInt(rate.split('-')[2])
        } else {
            rate = parseInt(discountRate)
        }

        let percent = 1 - rate / 100


        defaultHotProduct.forEach(item => {
            item.classList.add('hide')
        })
        discountHotProduct.forEach(item => {
            if (item.dataset.code != code) {
                item.remove()
            }
        })

        const productItems = document.querySelectorAll(`deal-swiper .deal-hot-discount-product.swiper-slide[data-code=${code}]`)

        const lang = document.querySelector('html').getAttribute('lang')
        const country = document.querySelector('html').dataset.country

        productItems.forEach(element => {
            element.classList.remove('hide')
            const poduct_item = element.querySelector('.grid-view-item')

            // 如果是up类型，需要判断产品折扣力度
            let rel_rate = rate
            let rel_percent = percent


            if (upTotype && poduct_item.getAttribute(`data-up-to-${rate}`)) {
                rel_rate = parseInt(poduct_item.getAttribute(`data-up-to-${rate}`))
                rel_percent = 1 - rel_rate / 100
                // console.log(rel_rate, rel_percent, 666666);
            }
            poduct_item.querySelector('.code-box .percent').textContent = rel_rate + '%';
            if (!('en,de,es').includes(lang)) {
                poduct_item.querySelector('.code-box .percent').textContent = '-' + rel_rate + '%';
            }
            poduct_item.querySelector('.discount-code').textContent = code
            // 货币符号
            // const currencyCode = poduct_item.querySelector('.discount-price .money')?.textContent[0] || poduct_item.querySelector('.discount-price').textContent[0]
            const final_price = poduct_item.querySelector('.discount-price')

            const currency_item = parseCurrency(poduct_item.querySelector('.line-through-price').textContent.trim())
            const currencyCode = currency_item.symbol
            const currencyPosition = currency_item.position

            // 去掉符号的对比价
            // const compare_price1 = poduct_item.querySelector('.line-through-price .money')?.textContent || poduct_item.querySelector('.line-through-price')?.textContent
            const compare_price = final_price.dataset.price
            let price = (Math.ceil(compare_price * rel_percent) / 100).toFixed(2)
            // console.log(currencyCode, final_price, compare_price, price, 6666);
            if (country == 'PH') (
                price = Number(price).toLocaleString('en-US')
            )
            if (currencyCode.includes('€')) {
                price = price.replace('.', ',')
            }
            let finalPrice = currencyCode + price
            if (lang == 'fr' && country == 'FR') {
                finalPrice = price + currencyCode
            } else if (lang == 'de' && country == 'DE') {
                finalPrice = price + currencyCode
            } else if (currencyPosition == 'suffix') {
                finalPrice = price + currencyCode
            }

            final_price.textContent = finalPrice

            // 修改弹窗的内容
            const product_handle = poduct_item.dataset.handle
            const dialog_item = document.querySelector(`.product_detail_main .product_item[data-handle=${product_handle}][data-code=${code}]`)
            const dialog_percent = dialog_item.querySelector('.code-box .percent')
            if (dialog_percent) {
                dialog_percent.textContent = rel_rate + '%';
            }
            dialog_item.querySelector('.discount-code').textContent = code
            const dialog_final_price = dialog_item.querySelector('.discount-price .money') || poduct_item.querySelector('.discount-price')
            dialog_final_price.textContent = finalPrice

            // reviews:修改当前code的产品的价格
            const reviews_product_item = dealsReviewsContainer.querySelector(`.swiper-slide[data-handle=${product_handle}][data-code=${code}]`)
            reviews_product_item.querySelector('.discount-price').textContent = finalPrice

        });
        hotProductSwiper.updateSwiper()

        // reviews去掉不是当前code的产品
        discountReveiwsProduct.forEach(element => {
            if (element.dataset.code != code) {
                element.remove()
            } else {
                element.classList.remove('hide')
            }
        })
        // reviews：隐藏常规产品
        regularReveiwsProduct.forEach(element => {
            element.classList.add('hide')
        })
        dealsReviewsContainer.updateSwiper()

        // if (code == 'FIND') {
        //     $('.discount_find_button').removeClass('hide')
        // }


    }








    const discountCode = new URLSearchParams(window.location.search).get('discount')?.toUpperCase();
    // const cookie_name = 'deals_code_' + discountCode

    // 有携带code就应用折扣码没有就不要
    if (discountCode) {
        const code_detail = codeDetail.find(
            item => item.code === discountCode
        );

        if (code_detail && code_detail.handles.includes(currentHandle)) {
            // 第一次进来也要判断是否折扣码位过期
            const endtime = code_detail.expiry_time
            // console.log(Date.now() < new Date(endtime).getTime(), 8888);

            if (Date.now() < new Date(endtime).getTime() || !endtime) {
                discountRate = code_detail.percent
                updataDiscountCode(discountCode)
                updateProductMessage(discountCode)
            } else {
                updataDiscountCode('')
            }
        }
    } else {
        updataDiscountCode('')
    }

    // 拿最后一次带折扣码链接的code来判断
    // if (getCookie(localStorage.getItem('last_discount'))) {
    //     const code_data = JSON.parse(getCookie(localStorage.getItem('last_discount')))
    //     // 折扣码是否有效期内 
    //     const discountCode = code_data.code
    //     if (isStarted(discountCode)) {
    //         updataDiscountCode(discountCode)
    //         updateProductMessage(discountCode)

    //     }
    // }
    // 新的折扣码,没有cookies
    // else if (discountCode) {
    //     // 记录客户第一次进入的时间和折扣码，时间为延后一天
    //     const code_detail = codeDetail.find(
    //         item => item.code === discountCode
    //     );
    //     // 有设置折扣码且未过期才保存cookies
    //     if (code_detail && isStarted(discountCode)) {
    //         const code_data = JSON.stringify({
    //             code: discountCode,
    //             expire: Date.now() + 86400000
    //         })
    //         setCookie(cookie_name, code_data);
    //         // 第一次进来也要判断是否折扣码位过期

    //         updataDiscountCode(discountCode)
    //         updateProductMessage(discountCode)
    //     }
    // }







    //  产品弹窗
    const detailDialog = $('.product_detail_dialog');
    $('.deals-product-list .grid-view-item .quick-add-wrapper .show_detail').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        const handle = $(this).parents('.grid-view-item').data('handle');
        const code = $(this).parents('.swiper-slide').data('code');

        if (code) {
            const activeItem = $(`.product_detail_main .product_item[data-handle="${handle}"][data-code="${code}"]`);
            activeItem.removeClass('hide').siblings().addClass('hide');
        } else {
            $(`.product_detail_main .product_item[data-handle="${handle}"]`)
                .eq(0)
                .removeClass('hide')
                .siblings()
                .addClass('hide');
        }

        detailDialog.removeClass('hide');
        $('body').addClass('no-scroll');
    });

    $('.product_detail_dialog .dialog_close,.product_detail_dialog .dialog_overlayer').click(function () {
        detailDialog.addClass('hide');
        $('body').removeClass('no-scroll');
    });

    if (!customElements.get('media-swiper')) {
        customElements.define(
            'media-swiper',
            class MediaSwiper extends HTMLElement {
                // 监听的属性
                constructor() {
                    super();
                    this._swiper = null;
                    this._initialized = false;
                }

                connectedCallback() {
                    requestAnimationFrame(() => {
                        this._initSwiper();
                    });
                }

                _initSwiper() {
                    if (this._initialized) return;
                    const container = this.querySelector('.swiper');
                    const config = {
                        slidesPerView: 1,
                        loop: true,
                        pagination: {
                            el: this.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                        navigation: {
                            nextEl: this.querySelector('.swiper-button-next'),
                            prevEl: this.querySelector('.swiper-button-prev'),
                        },
                    };

                    this._swiper = new Swiper(container, config);
                    this._initialized = true;
                }

                disconnectedCallback() {
                    if (this._swiper) {
                        this._swiper.destroy(true, true);
                        this._swiper = null;
                        this._initialized = false;
                    }
                }
            }
        );
    }






    // 默认产品的倒计时
    const deals_product_container = document.querySelector('.deals-hot-product-list');
    var newlastdayHTML = deals_product_container.dataset.lastday;
    // var newcycledaysHTML = parseInt(deals_product_container.dataset.cycleday);
    var newcycledaysHTML = 1;

    let newtargetDate = new Date(newlastdayHTML);

    function newupdateCountdown() {
        const newnow = new Date();
        const cycleMs = newcycledaysHTML * 24 * 60 * 60 * 1000;

        // 先保证 targetDate 一定在未来（避免负数显示）
        while (newtargetDate.getTime() - newnow.getTime() <= 0) {
            newtargetDate = new Date(newtargetDate.getTime() + cycleMs);
        }

        let newtimeLeft = newtargetDate.getTime() - newnow.getTime();
        let newdays = Math.floor(newtimeLeft / (1000 * 60 * 60 * 24));

        // 按你的要求：当 days==0 时，叠加 cycleMs 继续倒计时
        if (newdays === 0) {
            newtargetDate = new Date(newtargetDate.getTime() + cycleMs);
            // 再次确保不为负
            while (newtargetDate.getTime() - newnow.getTime() <= 0) {
                newtargetDate = new Date(newtargetDate.getTime() + cycleMs);
            }
            newtimeLeft = newtargetDate.getTime() - newnow.getTime();
            newdays = Math.floor(newtimeLeft / (1000 * 60 * 60 * 24));
        }

        // 用非负的 newtimeLeft 来计算显示，避免出现 -3 / -15 / -34
        const newhours = String(Math.floor((newtimeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
        const newminutes = String(Math.floor((newtimeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
        const newseconds = String(Math.floor((newtimeLeft % (1000 * 60)) / 1000)).padStart(2, '0');

        const $daysEl = $('.deal-hot-regular-product .new-pro-residueDays-cycle');
        if (newdays <= 0) {
            $daysEl.addClass('hide').text('');
        } else if (newdays < 10) {
            $daysEl.removeClass('hide').text(` 0${newdays}:`);
        } else {
            $daysEl.removeClass('hide').text(` ${newdays}:`);
        }
        $('.deal-hot-regular-product .new-pro-residueHours-cycle').text(` ${newhours}:`);
        $('.deal-hot-regular-product .new-pro-residueMinutes-cycle').text(` ${newminutes}:`);
        $('.deal-hot-regular-product .new-pro-residueSeconds-cycle').text(` ${newseconds}`);
    }

    newupdateCountdown();
    setInterval(newupdateCountdown, 1000);

})